import {combineReducers} from 'redux';
import release from './latestRelease';
import login from './login';

export default combineReducers({
  login,
  release,
});
